import { gql } from '@apollo/client';

export const REPLY_FRAGMENT = gql`
    fragment ReplyFragment on Reply {
        id
        text
        createdAt
    }
`;
